if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: 2,
        spaceBetween: columnGap.mobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet
          },
          1024: {
            slidesPerView: parseInt(this.tabletLargeItems),
            spaceBetween: columnGap.tabletLarge
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop
          },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('testimonials-component', Testimonials);
}

// testimonial.js
document.addEventListener('DOMContentLoaded', function () {
  const CLAMP_LINES = 3;      // number of lines to show
  const CHAR_FALLBACK = 220; // fallback char length

  function initTestimonials() {
    const items = document.querySelectorAll('.testimonial__content');
    if (!items.length) return;

    items.forEach(content => {
      if (content.dataset.truncated) return;

      // Measure width safely
      const rect = content.getBoundingClientRect();
      if (!rect.width) return;

      // Create hidden clone for height measurement
      const clone = content.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.width = Math.floor(rect.width) + 'px';
      clone.style.left = '-9999px';
      document.body.appendChild(clone);

      const fullHeight = clone.scrollHeight;

      // Apply clamp styles to clone
      clone.style.display = '-webkit-box';
      clone.style.webkitBoxOrient = 'vertical';
      clone.style.webkitLineClamp = CLAMP_LINES;
      clone.style.overflow = 'hidden';
      const clampedHeight = clone.getBoundingClientRect().height;

      document.body.removeChild(clone);

      // If content overflows → line clamp version
      if (fullHeight > clampedHeight + 1) {
        content.classList.add('clamped');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'testimonial-toggle';
        btn.textContent = 'Read more';

        btn.addEventListener('click', () => {
          const expanded = content.classList.toggle('expanded');
          btn.textContent = expanded ? 'Read less' : 'Read more';
        });

        content.insertAdjacentElement('afterend', btn);
        content.dataset.truncated = '1';
        return;
      }

      // Fallback character-based truncation
      const plainText = content.textContent.trim();
      if (plainText.length > CHAR_FALLBACK) {
        const shortSpan = document.createElement('span');
        shortSpan.className = 'testimonial-short';
        shortSpan.textContent = plainText.slice(0, CHAR_FALLBACK) + '…';

        const fullSpan = document.createElement('span');
        fullSpan.className = 'testimonial-full';
        fullSpan.style.display = 'none';
        fullSpan.innerHTML = content.innerHTML;

        content.innerHTML = '';
        content.appendChild(shortSpan);
        content.appendChild(fullSpan);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'testimonial-toggle';
        btn.textContent = 'Read more';

        btn.addEventListener('click', () => {
          const isOpen = btn.textContent === 'Read less';
          shortSpan.style.display = isOpen ? '' : 'none';
          fullSpan.style.display = isOpen ? 'none' : '';
          btn.textContent = isOpen ? 'Read more' : 'Read less';
        });

        content.insertAdjacentElement('afterend', btn);
      }

      content.dataset.truncated = '1';
    });
  }

  // Retry init (handles sliders / delayed layout)
  function tryInit(retries = 6, delay = 300) {
    initTestimonials();
    if (retries <= 0) return;
    setTimeout(() => tryInit(retries - 1, delay), delay);
  }

  tryInit();

  // Re-initialize on window resize
  let resizeTimer;
  let lastWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      const currentWidth = window.innerWidth;

      if (currentWidth === lastWidth) return;

      lastWidth = currentWidth;

      // Reset everything
      document.querySelectorAll('.testimonial__content').forEach(content => {
        content.classList.remove('clamped', 'expanded');
        delete content.dataset.truncated;
      });

      document.querySelectorAll('.testimonial-toggle').forEach(btn => btn.remove());

      initTestimonials();
    }, 300);
  });
});